import { all, put, call, take, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { SET_ZWALLET_TRANSFER, LOAD_BANK_LIST } from './types';
import { fetchBanks, setRedirect } from './actions';
import { zwalletTransferGraphQL, bankListGraphQL } from './graphql';
import { loadOperationsAction } from '../Operations/actions';
import { loadDashboardCards } from '../Dashboard/actions';
import { errorAlert, successAlert } from '../../Common/alerts';

function* zwalletTransfer(action) {
    const { payload } = action;

    try {
        const user = yield select(state => state.user);

        yield call(zwalletTransferGraphQL, { payload, user });

        yield put(loadOperationsAction({ filter: "", value: ""}));
        yield put(loadDashboardCards());
        yield take(["SET_OPERATIONS", "DASHBOARD_CARDS_VALUE"]);

        successAlert(
          "Transferência enviada",
          "Transferência enviada com sucesso, a transferência será confirmado em breve e o comprovante estará disponível para ser baixado."
        );

        yield put(setRedirect(true));
    } catch(error) {
        errorAlert("Ops...", error);
    }
}

function* watchZwalletTransfer() {
    yield takeLatest(SET_ZWALLET_TRANSFER, zwalletTransfer);
}

function* bankList() {
    try {
        const { banks } = yield call(bankListGraphQL);
        yield put(fetchBanks(banks));
    } catch(error) {
        errorAlert("Ops...", error);
    }
}

function* watchBankList() {
    yield takeEvery(LOAD_BANK_LIST, bankList);
}

export default function* rootSaga() {
  yield all([
    watchBankList(),
    watchZwalletTransfer()
  ]);
}


// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/sagas.js